import React from 'react';
import apartmentComplexImage from '../img/elevation_img_15.avif';
import  useScrollToTop from './useScrollToTop';
import './ProjectStyles.css';

const LuxuryApartmentComplex = () => {
  useScrollToTop();
  return (
    <div className='project-container'>
      <h2>Luxury Apartment Complex</h2>
      <img className='project-image' src={apartmentComplexImage} alt="Luxury Apartment Complex" />
      <div className='project-details'>
        <p className='project-description'>
          Indulge in an elevated living experience at our prestigious apartment complex, where sophisticated design meets unparalleled comfort and convenience. Each residence is meticulously crafted with high-end finishes and thoughtful details, creating an oasis of tranquility in the heart of the city.
        </p>
        <h3>Exclusive Features & Amenities:</h3>
        <ul>
          <li>A selection of elegantly appointed apartments, including spacious studios, one, two, and three-bedroom residences, as well as exclusive penthouse suites.</li>
          <li>Gourmet kitchens featuring custom Italian cabinetry, premium stainless steel appliances, and quartz countertops.</li>
          <li>Expansive living areas with floor-to-ceiling windows offering breathtaking city or waterfront views.</li>
          <li>Luxurious bathrooms with designer fixtures, rainfall showerheads, and deep soaking tubs in select units.</li>
          <li>Private balconies or terraces in most apartments, perfect for enjoying the cityscape.</li>
          <li>Smart home technology integration for seamless control of lighting, climate, and security.</li>
          <li>Dedicated resident lounge with a fireplace and comfortable seating areas.</li>
          <li>State-of-the-art fitness center equipped with the latest cardio and strength training equipment, as well as a yoga studio.</li>
          <li>Rooftop infinity pool and sundeck with panoramic views, cabanas, and a barbecue area.</li>
          <li>Tranquil spa and wellness center offering massage treatments and relaxation rooms.</li>
          <li>Business center with high-speed internet access, printing facilities, and private meeting rooms.</li>
          <li>Children's play area and indoor recreation room.</li>
          <li>Pet-friendly environment with a dedicated dog run and grooming station.</li>
          <li>24/7 concierge services to assist with resident needs, including package handling and appointment scheduling.</li>
          <li>Secure, controlled-access parking garage with electric vehicle charging stations.</li>
          <li>On-site dry cleaning and laundry services.</li>
          <li>Resident events and social gatherings organized regularly.</li>
        </ul>
        <h3>Available Residences:</h3>
        <ul>
          <li>
            <strong>Penthouse Suite:</strong> Expansive 3 Bedrooms, 3.5 Baths, Private Elevator Access, Wrap-around Terrace with Stunning Panoramic City Views - Starting at $10,000/month
          </li>
          <li>
            <strong>Luxury Three-Bedroom Apartment:</strong> 3 Bedrooms, 3 Baths, Gourmet Kitchen, Spacious Balcony with Ocean View - Starting at $6,500/month
          </li>
          <li>
            <strong>Deluxe Two-Bedroom Apartment:</strong> 2 Bedrooms, 2 Baths, Modern Design, Private Balcony - Starting at $4,500/month
          </li>
          <li>
            <strong>Spacious One-Bedroom Apartment:</strong> 1 Bedroom, 1 Bath, Open Floor Plan, City Views - Starting at $3,000/month
          </li>
          <li>
            <strong>Stylish Studio Apartment:</strong> Open-concept Layout, Modern Finishes, Efficient Design - Starting at $2,200/month
          </li>
        </ul>
        <p>
          Each apartment includes complimentary high-speed internet access, water, and trash removal services. Residents are responsible for electricity and cable television. Flexible lease terms are available.
        </p>
        <p>
          Located in a vibrant neighborhood with easy access to fine dining, upscale shopping, cultural attractions, and public transportation, our luxury apartment complex offers an unparalleled urban living experience.
        </p>
        <p>
          Contact our dedicated leasing team today to schedule a private tour and discover your new exceptional home.
        </p>
      </div>
    </div>
  );
};

export default LuxuryApartmentComplex;